import React__default from 'react';
import { StyleSheet, View } from 'react-native';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { a as AppIcon } from './index-6b88191c.esm.js';

const AppSlider = _ref => {
  let {
    index = 1,
    indicator = true,
    IndicatorComponent = AppIcon,
    items = [],
    onIndicatorClick,
    styleIndicatorWrapper,
    styleSliderWrapper,
    isIndicatorComponentClickableToMoveForward = true
  } = _ref;
  let indicators = [];
  for (let i = 1; i <= items.length; i++) {
    indicators.push( /*#__PURE__*/React__default.createElement(IndicatorComponent, {
      icon: AppAssets.icons.uncheck,
      isClickable: isIndicatorComponentClickableToMoveForward || index > i,
      key: i,
      onPress: () => {
        onIndicatorClick(i);
      },
      style: [styles.indicator, {
        opacity: index === i ? 1 : 0.3
      }]
    }));
  }
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.sliderWrapper, styleSliderWrapper]
  }, items[index - 1], indicator && /*#__PURE__*/React__default.createElement(View, {
    style: [styles.indicatorWrapper, styleIndicatorWrapper]
  }, indicators));
};
const styles = StyleSheet.create({
  indicator: {
    marginHorizontal: 20,
    maxWidth: 24
  },
  indicatorWrapper: {
    flexDirection: "row",
    justifyContent: "center",
    overflow: "hidden",
    marginVertical: 20
  },
  sliderWrapper: {}
});
AppSlider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppSlider",
  "props": {
    "index": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "required": false
    },
    "indicator": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "IndicatorComponent": {
      "defaultValue": {
        "value": "AppIcon",
        "computed": true
      },
      "required": false
    },
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "isIndicatorComponentClickableToMoveForward": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppSlider as A };
